import React from "react";
import { Col } from "react-bootstrap";
import {
  LoadingListItemThumb,
  LoadingListItemDate,
  LoadingEventListItemText,
  LoadingEventListItemContainerRow,
} from "../../../utils/loading-styles";

export const LoadingEventListItem = () => {
  return (
    <>
      <LoadingEventListItemContainerRow>
        <Col xs={12} md={3}>
          <LoadingListItemThumb>
            &nbsp;
          </LoadingListItemThumb>
        </Col>
        <LoadingListItemDate xs={12} md={3}>
          <h4>&nbsp;</h4>
          <span>
            <h1>&nbsp;</h1>
          </span>
        </LoadingListItemDate>
        <LoadingEventListItemText xs={12} md={6}>
          <h4>&nbsp;</h4>
          <span>
            &nbsp;
          </span>
        </LoadingEventListItemText>
      </LoadingEventListItemContainerRow>
    </>
  );
};
